module.exports = __webpack_public_path__ + "static/Invoice-System-2-432ec69ede822aee3e92a4efa23239fa.svg";